import SimpleParallax from 'simple-parallax-js/vanilla';

class SimpleParallaxController {
    constructor() {
        this.instance = null;
        this.hasRun = false;
        this.run = this.run.bind(this);
    }

    run() {
        console.log('simpleParallax: run called');
        if (this.hasRun) return;

        const images = document.querySelectorAll('.simpleParallaxImg');
        if (!images.length) {
            console.log('simpleParallax: no .simpleParallaxImg found');
            return;
        }

        this.instance = new SimpleParallax(images, {
            orientation: 'up',      // vertical movement to be noticeable on scroll
            scale: 1.8,             // slightly zoomed to leave margin for translate
            delay: 1,            // smoother easing
            maxTransition: 80,      // larger translate range so effect is obvious
            overflow: true          // keep your own container, avoid extra wrapper
        });

        console.log('simpleParallax: instance created', this.instance);
        this.hasRun = true;
    }

    init() {
        if (document.readyState === 'complete') {
            this.run();
        } else {
            window.addEventListener('load', this.run, { once: true });
        }
    }
}

const simpleParallax = new SimpleParallaxController();
export { simpleParallax };
